module.exports = __webpack_public_path__ + "static/media/SG-MobileImg.f4492cbe.png";